import { render, staticRenderFns } from "./TimberTableAverageResults.vue?vue&type=template&id=dc6e5fda&"
import script from "./TimberTableAverageResults.vue?vue&type=script&lang=js&"
export * from "./TimberTableAverageResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports